module.exports = __webpack_public_path__ + "img/xaas-fab.d375b93.svg";